// @flow
import React from "react";
import { css } from "styled-components";
import { media } from "../../media";

import { type Props } from "./shared";
import { MobileBuyingSellingSlice } from "./MobileBuyingSelling";
import { TabletBuyingSellingSlice } from "./TabletBuyingSelling";
import { DesktopBuyingSellingSlice } from "./DesktopBuyingSelling";

export const BuyingAndSelling = (props: Props) => (
  <>
    <div
      css={css`
        display: flex;

        ${media.tablet`
          display: none;
        `}
      `}
    >
      <MobileBuyingSellingSlice {...props} />
    </div>
    <div
      css={css`
        display: none;

        ${media.tablet`
          display: flex;
        `}

        ${media.desktop`
          display: none;
        `}
      `}
    >
      <TabletBuyingSellingSlice {...props} />
    </div>

    <div
      css={css`
        display: none;

        ${media.desktop`
          display: flex;
        `}
      `}
    >
      <DesktopBuyingSellingSlice {...props} />
    </div>
  </>
);
